export default __webpack_public_path__ + "static/media/user_outlinedd.34fbfeb3.svg";